<template>
  <gj-modal
      size="normal"
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
  >
    <template #header>导入</template>
    <template #content>
      <div class="gj-mb16">
        <div class="gj-mb16">
          <div class="gj-mb16">
            <gj-required>月份</gj-required>
            <gj-date-picker
                style="margin-left: 10px"
                type="monthrange"
                v-model="date"
                :clearable="false"
                width="220px"
            ></gj-date-picker>
          </div>
          <div v-if="type === 'SKU'">
            <gj-required>仓库</gj-required>
            <gj-warehouse-select
                style="margin-left: 10px"
                :self="type === 'SKU'"
                :fba="type === 'MSKU'"
                multiple
                :placeholder="type === 'SKU' ? '所有自营仓':'所有FBA仓'"
                v-model="warehouseIds"
                width="220px"
            ></gj-warehouse-select>
          </div>

          <template v-else>
            <div class="gj-mb16" style="padding-left: 6px;">
              国家
              <gj-select
                  style="margin-left: 10px"
                  v-model="countryMarketValue.countrys"
                  :options="countryList"
                  type="multi-check"
                  placeholder="全部国家"
                  :width="'220px'"
                  clearable
                  :filterable="false"
                  @change="countryChange"
              ></gj-select>
            </div>
            <div style="padding-left: 6px;">
              店铺
              <gj-select
                  style="margin-left: 10px"
                  v-model="countryMarketValue.markets"
                  :options="marketList"
                  type="multi-check"
                  placeholder="全部店铺"
                  :width="'220px'"
                  clearable
                  :filterable="false"
              ></gj-select>
            </div>
          </template>


<!--          <gj-country-server-select-->
<!--              v-else-->
<!--              v-model="countryMarketValue"-->
<!--              :column="true"-->
<!--              :width="['220PX','220PX']"-->
<!--          ></gj-country-server-select>-->
        </div>
        <gj-upload
            :template-url="templateUrl"
            @uploadAfter="uploadAfter"
            :accept-type="[FileTypeEnum.XLSX, FileTypeEnum.XLS, FileTypeEnum]"
            container-type="costCenter"
            :uploadText="uploadText"
        >
          <template #tip>
            <span>只能上传xls/xlsx文件</span>
          </template>
        </gj-upload>
      </div>
      <gj-import-alert
          :rules="[
              `建议导入数据不超过5000行`,
            `模板中的表头不可更改，不能删除`,
            `同一个${ type }+仓库存在多条记录，以最后一条记录为准`,
            `系统会自动在文件中给出可维护成本的${ type }信息`,
            `多次导入只会储存最新一次，利润报表模块需要重算才会获取最新一次成本数据`,
            `成本仅支持人民币币种，保留小数点后四位`,
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, uploadMixin} from "../../../../minxins";
import {isMeaningful} from "../../../../utils/common";
import {importCostCenter,queryMarketByCountryCode} from "../../../../api/finance";
import {convertToMonth} from "../../../../utils/date.util";
import {FileTypeEnum} from "@/components/upload/enum";

export default {
  name: "cost-center-import",
  mixins: [modalMixIn, uploadMixin],
  props: {
    type:null,
    //国家列表
    countryList:{
      type:Array,
      default: () => []
    }
  },
  created() {
    queryMarketByCountryCode([]).then(res => {
      this.marketList = res;
    })
  },
  data() {
    return {
      date: [new Date(), new Date()],
      warehouseIds: [],
      FileTypeEnum,
      countryMarketValue:{
        countrys:[],
        markets:[]
      },
      //店铺列表
      marketList:[],
      uploadText:'数据导入成功，数据沿用无法立即生效，请耐心等待'
    }
  },
  computed:{
    templateUrl:function (){
      // let warehouseIds = '';
      // if(this.type === 'SKU'){
      //   warehouseIds = this.getWarehouseIds()
      //   // return `/finance/financialMonthCost/downloadTemplate?warehouseIds=${this.getWarehouseIds()}&type=${this.getType()}`
      // }else {
      //   //若选中店铺，仓库id取店铺的
      //   if(this.countryMarketValue.markets.length>0){
      //     warehouseIds = this.countryMarketValue.markets.join(',')
      //   }
      //   //若未选中店铺，且选中了国家，仓库id取国家的
      //   else if(this.countryMarketValue.countrys.length>0){
      //     warehouseIds = this.countryMarketValue.countrys.join(',')
      //   }
      //   // if (isMeaningful(this.countryMarketValue)) {
      //     // return `/finance/financialMonthCost/downloadTemplate?countryCodes=${this.countryMarketValue.countryIds.join(',')}&marketIds=${this.countryMarketValue.marketIds.join(',')}&type=${this.getType()}`
      //   // }else {
      //   //   return `/finance/financialMonthCost/downloadTemplate?countryCodes=&marketIds=&type=${this.getType()}`
      //   // }
      // }
      return `/finance/financialMonthCost/downloadTemplate?warehouseIds=${this.getIds()}&type=${this.getType()}`
    }
  },
  methods: {
    getIds(){
      if(this.type === 'SKU'){
        return this.warehouseIds.join(',')
      }else {
        let warehouseIds = '';
        //若选中店铺，仓库id取店铺的
        if(this.countryMarketValue.markets.length>0){
          warehouseIds = this.countryMarketValue.markets.join(',')
        }
        //若未选中店铺，且选中了国家，仓库id取国家的
        else if(this.countryMarketValue.countrys.length>0){
          warehouseIds = this.countryMarketValue.countrys.join(',')
        }
        return warehouseIds
      }
    },
    //切换国家回调
    countryChange(){
      this.countryMarketValue.markets = [];
      let param = this.countryList.filter(m => m.checked).map(r => {
        if (r.text.indexOf('EU') > -1) {
          return 'EU'
        } else {
          return r.text
        }
      })
      queryMarketByCountryCode(param).then(res => {
        this.marketList = res;
      })
    },
    // getWarehouseIds() {
    //   return isMeaningful(this.warehouseIds) ? this.warehouseIds.join(',') : '';
    // },
    getType() {
      return this.type === 'MSKU' ? 'FBA' : 'SELF'
    },
    beforeUpload() {
      if(this.warehouseIds.length===0){
        this.$message.error("请选择仓库！")
        return false
      }
      return true;
    },
    uploadAfter(attId, data, uploadCb) {
      this.importHandleLoading = true;
      let params;
      // let param = {
      //   attachmentId: attId,
      //   beginMonth: convertToMonth(this.date[0]),
      //   endMonth: convertToMonth(this.date[1]),
      //   type: this.getType(),
      // };
      // let warehouseIds = '';
      // if(this.type === 'SKU'){
      //   warehouseIds = this.getWarehouseIds()
      //   // params = `attachmentId=${attId}&beginMonth=${convertToMonth(this.date[0])}&endMonth=${convertToMonth(this.date[1])}&warehouseIds=${this.getWarehouseIds()}&type=${this.getType()}`
      //   // param.warehouseIds = this.getWarehouseIds();
      // }else {
      //
      //   // if (isMeaningful(this.countryMarketValue)) {
      //   //   params = `attachmentId=${attId}&beginMonth=${convertToMonth(this.date[0])}&endMonth=${convertToMonth(this.date[1])}
      //   //   &countryCodes=${this.countryMarketValue.countryIds.join(',')}&marketIds=${this.countryMarketValue.marketIds.join(',')}&type=${this.getType()}`
      //   // }else {
      //   //   params = `attachmentId=${attId}&beginMonth=${convertToMonth(this.date[0])}&endMonth=${convertToMonth(this.date[1])}
      //   //   &countryCodes=&marketIds=&type=${this.getType()}`
      //   // }
      //   //若选中店铺，仓库id取店铺的
      //   if(this.countryMarketValue.markets.length>0){
      //     warehouseIds = this.countryMarketValue.markets.join(',')
      //   }
      //   //若未选中店铺，且选中了国家，仓库id取国家的
      //   else if(this.countryMarketValue.countrys.length>0){
      //     warehouseIds = this.countryMarketValue.countrys.join(',')
      //   }
      // }
      params = `attachmentId=${attId}&beginMonth=${convertToMonth(this.date[0])}&endMonth=${convertToMonth(this.date[1])}
          &warehouseIds=${this.getIds()}&type=${this.getType()}`
      importCostCenter(params).then((res) => {
            this.$gjImportHandle(res, uploadCb);
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.importHandleLoading = false);
    }
  }
}
</script>

<style scoped lang="scss">
.gj-import-alert {
  font-size: 12px;
  margin-bottom: 10px;
}

.gj-import-alert--title {
  margin-bottom: 10px;
}

.gj-import-alert--title,
.gj-import-alert--content {
  color: #003b80;
}

.gj-import-alert--rule {
  margin-bottom: 5px;
  font-size: 12px;
}

.el-alert--warning {
  background-color: #e5f0ff;
}
/deep/ .flex-direction-column > div {
  margin-left: 0 !important;
  .gj-select{
    margin-left: 10px;
  }
}
</style>
